import http from './http';

/// MusteriMakina
export function getMusteriMakina() {
    return http.get(`/musterimakina`);
}

export function getMusteriMakinaDetail(id) {
    return http.get(`/musterimakina/detail/${id}`);
}

export function getMusteriMakinaByMusteriId(id) {
    return http.get(`/musterimakina/musteri/${id}`);
}

export function createMusteriMakina(data) {
    return http.post(`/musterimakina/create`, data);
}

export function updateMusteriMakina(id, data) {
    return http.put(`/musterimakina/update/${id}`, data);
}

export function deleteMusteriMakina(id) {
    return http.delete(`/musterimakina/delete/${id}`);
}
